import { BASE_DOMAIN } from '~/core/constants'
import { getUtcString } from '~/core/utils'
import envData from '~/core/env'

const cookies = {
  get auth () {
    return envData.authCookie
  }
}

const getCookieName = key => key in cookies
  ? cookies[key]
  : undefined

const setCookie = (name, value = '', options) => {
  const cookieParts = [
    [name, value],
    ...Object.entries(options)
  ]

  document.cookie = cookieParts
    .map(pair => pair.join('='))
    .join(';')
}

export const clearAuthCookie = () =>
  setCookie(getCookieName('auth'), '', {
    domain: BASE_DOMAIN,
    expires: getUtcString(0)
  })

export const setAuthCookie = expireAt =>
  setCookie(getCookieName('auth'), new URL('/', window.location).href, {
    domain: BASE_DOMAIN,
    expires: getUtcString(expireAt)
  })
